export default {
  inspector: {
    name: '',
    address: '',
    postCode: '',
    tel: '',
    gasRegNumber: ''
  },
  inspectionAddress: {
    name: '',
    address: '',
    postCode: '',
    tel: '',
    tenantName: '',
    tenantPresent: 'YES'
  },
  landlord: {
    name: '',
    address: '',
    postCode: '',
    tel: ''
  },
  appliances: [
    {
      location: '',
      type: '',
      make: '',
      model: '',
      flueType: '',
      operatingPressure: '',
      heatInputActual: '',
      gasRateMeterReading: '',
      gasRateSeconds: 120,
      meterUnit: 'metric (m³)',
      meterPressure: 21,
      appliancePressure: '',
      smokeMatchSpillage: '',
      smokeMatchVentilation: '',
      flueTerminationSatisfactory: '',
      visualCondition: '',
      adequateVentilation: '',
      applianceSafeToUse: '',
      landlordsAppliance: '',
      inspected: '',
      combustionAnalysisDone: 'No',
      coPpm: '',
      co2Pct: '',
      o2Pct: '',
      flueGasTempC: ''
    }
  ],
  soundnessTest: {
    result: '',
    warningNoticeIssued: 'No',
    warningStickerFitted: 'No'
  },
  faultsAndRectification: {
    details: ''
  },
  certification: {
    numberOfAppliances: 1,
    nextCheckMonths: 12,
    inspectionDate: new Date().toISOString().split('T')[0],
    certificateNumber: `GS${Date.now()}`,
    engineerSignature: '',
    engineerPrintName: ''
  },
  landlordReceipt: {
    signature: '',
    recipientType: '',
    receiptDate: ''
  }
};
